import format from 'date-fns/format';
import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import ja from 'date-fns/locale/ja';

export const getFormattedDate = (date, formatString, locale) => {
  const dateLocales = { en, de, es, ja };

  let localizedFormatString = formatString;

  if (locale === 'de') {
    localizedFormatString = localizedFormatString
      .split(' ')
      .map((part) =>
        part && part.charAt(part.length - 1) === 'd' ? `${part}.` : part
      )
      .join(' ');
  }

  return format(new Date(date), localizedFormatString, {
    locale: dateLocales[locale],
  });
};
